import LegalLayout, { H2, H3, P, UL, PH } from "../LegalLayout";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <P>
        Der Schutz deiner persönlichen Daten ist uns wichtig. Diese Datenschutzerklärung informiert dich über die
        Verarbeitung deiner Daten im MAZARO-Onlineshop und passt zu den tatsächlich eingesetzten Techniken.{" "}
        <strong>Stand der Technik: siehe jeweiliger Abschnitt.</strong>
      </P>

      <H2>1. Verantwortlicher</H2>
      <PH>
        [Vor- und Nachname des Inhabers, Straße und Hausnummer, PLZ und Ort, E-Mail: support@mazaro.de, Telefon:
        Placeholder — identisch mit dem Impressum]
      </PH>

      <H2>2. Hosting &amp; Server-Logfiles</H2>
      <P>
        Diese Webseite wird über die Hosting-Plattform <strong>Emergent</strong> (App-Server, Datenbank, Auslieferung über
        die Domain deiner Wahl) betrieben. Beim Aufruf der Seite verarbeitet der Hoster technisch notwendige
        Zugriffsdaten:
      </P>
      <UL
        items={[
          "gekürzte IP-Adresse",
          "Datum und Uhrzeit des Zugriffs",
          "aufgerufene Seite / HTTP-Status",
          "Browser und Betriebssystem (User-Agent)",
        ]}
      />
      <P>
        Rechtsgrundlage ist unser berechtigtes Interesse an einem sicheren, stabilen Betrieb (Art. 6 Abs. 1 lit. f DSGVO).
        <PH>Serverstandort und Speicherdauer der Logfiles beim Hoster prüfen und hier eintragen [z.B. EU / USA].</PH>
      </P>

      <H2>3. Kontakt &amp; VIP-Anmeldung (E-Mail-Liste)</H2>
      <UL
        items={[
          <>
            <strong>VIP Ring Club / Coming-Soon-Anmeldung:</strong> Wir speichern deine E-Mail-Adresse, den Zeitpunkt der
            Anmeldung und einen Spamschutz-Zähler, um dir Drop- und Launch-Nachrichten schicken zu können (Art. 6 Abs. 1
            lit. a bzw. f DSGVO). Du kannst dich jederzeit über den Abmelde-Link in jeder E-Mail oder per Nachricht an
            support@mazaro.de abmelden.
          </>,
          <>
            <strong>Kontaktformular:</strong> Name, E-Mail-Adresse und deine Nachricht werden zur Beantwortung deiner
            Anfrage gespeichert (Art. 6 Abs. 1 lit. b DSGVO) und nach abschließender Bearbeitung gelöscht, sofern keine
            gesetzlichen Aufbewahrungspflichten bestehen.
          </>,
        ]}
      />
      <PH>
        Aktuelles Verfahren: Die VIP-Anmeldung speichert die Adresse direkt nach Formular-Absenden (Bestätigungs-E-Mail
        geht hinaus, aber ohne Klick-Verifizierung). Für rechtliche Sicherheit wird ein Double-Opt-in-Verfahren
        empfohlen und kann auf Wunsch eingebaut werden.
      </PH>

      <H2>4. Kundenkonto (Registrierung &amp; Login)</H2>
      <UL
        items={[
          "E-Mail-Adresse, Name (freiwillig), Nutzer-ID, Anmelde-Art (Passwort oder Google), Zeitpunkt der Registrierung",
          "Passwörter werden ausschließlich als bcrypt-Hash gespeichert — niemals im Klartext",
          "Zum Login-Schutz: Bei 5 fehlgeschlagenen Versuchen wird die Kombination aus IP-Adresse und E-Mail für 15 Minuten gesperrt",
        ]}
      />
      <P>Rechtsgrundlage: Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO). Du kannst dein Konto jederzeit löschen lassen.</P>

      <H2>5. Google-Anmeldung (OAuth)</H2>
      <P>
        Du kannst dich über „Mit Google anmelden“ registrieren. Dabei werden E-Mail-Adresse, Name und — sofern
        freigegeben — dein Profilbild von Google an uns übermittelt. Die technische Abwicklung läuft über die
        OAuth-Schnittstelle von Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, im Auftrag der
        Plattform Emergent. Rechtsgrundlage: Art. 6 Abs. 1 lit. a und b DSGVO.
      </P>

      <H2>6. Zahlungen (Stripe)</H2>
      <P>
        Bei Bestellungen läuft die Zahlungsabwicklung über <strong>Stripe</strong> (Stripe Payments Europe Ltd., 1
        Grand Canal Street Lower, Dublin, Irland — Muttergesellschaft: Stripe, Inc., USA). Dabei werden mindestens
        folgende Daten an Stripe übermittelt bzw. von Stripe verarbeitet: Bestellinhalt, Betrag, Währung,
        E-Mail-Adresse, Rechnungsadresse, IP-Adresse sowie Zahlungsdaten (z.B. Karteninformationen — verarbeitet
        ausschließlich durch Stripe). In unserer Datenbank speichern wir dazu die Stripe-Session-ID, Bestellinhalt,
        Betrag, Währung, Zahlstatus und Stripe-Zahlungs-ID — niemals Kartennummern.
      </P>
      <P>
        Rechtsgrundlage: Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO). Datenschutzhinweise von Stripe:{" "}
        <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer" className="text-gold underline underline-offset-4">
          https://stripe.com/privacy
        </a>
      </P>

      <H2>7. E-Mail-Versand</H2>
      <P>
        Bestätigungs- und Bestell-E-Mails versenden wir über den verwalteten E-Mail-Dienst der Emergent-Plattform
        (Weiterleitung an den E-Mail-Dienst Resend, Inc.). Dabei übermitteln wir ausschließlich die Empfängeradresse,
        den Betreff und den vorbereiteten E-Mail-Inhalt. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vertragliche
        Kommunikation) bzw. lit. a (Informationen zum Drop).
      </P>

      <H2>8. KI-Chatbot (Claude)</H2>
      <P>
        Die Seite bietet einen KI-Chat („Fight Concierge“, betrieben über die Emergent-Plattform mit dem Modell Claude
        von Anthropic, USA) an. Chat-Nachrichten und die Session-Kennung werden in unserer Datenbank gespeichert und zur
        Beantwortung an das KI-Modell übermittelt. <strong>Aktueller Stand: Der Chat ist derzeit deaktiviert.</strong>{" "}
        Falls aktiviert, gilt: Keine Eingabe von persönlichen Daten im Chat erforderlich — nutze den Chat nur für
        Produktfragen.
      </P>

      <H2>9. Cookies</H2>
      <UL
        items={[
          "access_token (15 Minuten) — für den angemeldeten Zustand, technisch notwendig",
          "refresh_token (7 Tage) — für die automatische Verlängerung der Anmeldung, technisch notwendig",
          "session_token (7 Tage) — nur bei Google-Anmeldung, technisch notwendig",
        ]}
      />
      <P>
        Alle Cookies sind technisch notwendig (Art. 6 Abs. 1 lit. f / § 25 Abs. 2 TTDSG) und „HttpOnly“ — sie können von
        Skripten nicht gelesen werden. <strong>Es gibt keine Analyse-, Tracking- oder Marketing-Cookies.</strong>
      </P>

      <H2>10. Empfänger &amp; Datenübertragung in Drittländer</H2>
      <P>
        Empfänger deiner Daten sind neben uns: Emergent (Hosting, E-Mail-Versand, KI-Integration), Stripe (Zahlungen,
        Irland/USA) und Google (OAuth, USA). Für Übertragungen in die USA bestehen Standardvertragsklauseln bzw.
        angemessene Garantien der jeweiligen Anbieter.
        <PH>
          Konkrete Garantien (z.B. EU-Standardvertragsklauseln, Data-Privacy-Framework-Zertifizierung) der einzelnen
          Anbieter prüfen und hier konkret benennen.
        </PH>
      </P>

      <H2>11. Deine Rechte</H2>
      <UL
        items={[
          "Auskunft (Art. 15 DSGVO)",
          "Berichtigung (Art. 16) und Löschung (Art. 17)",
          "Einschränkung der Verarbeitung (Art. 18) und Datenübertragbarkeit (Art. 20)",
          "Widerspruch gegen Verarbeitungen auf Basis berechtigter Interessen (Art. 21)",
          "Widerruf erteilter Einwilligungen (Art. 7 Abs. 3) — z.B. der VIP-Anmeldung",
        ]}
      />
      <P>
        Für alle Rechte genügt eine E-Mail an support@mazaro.de. Zudem hast du das Recht, dich bei einer
        Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO).
      </P>

      <H2>12. Datensicherheit</H2>
      <P>
        Die Übertragung erfolgt verschlüsselt über HTTPS. Passwörter werden mit bcrypt gehasht, Zahlungen laufen
        ausschließlich über Stripe — Kartendaten gelangen nie in unsere Systeme.
      </P>
    </LegalLayout>
  );
}
